import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider } from '@/context/AuthContext';
import LandingPage from '@/pages/LandingPage';
import AuthPage from '@/pages/AuthPage';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import MembersPage from '@/pages/MembersPage';
import NotesPage from '@/pages/NotesPage';
import TasksPage from '@/pages/TasksPage';
import AppointmentsPage from '@/pages/AppointmentsPage';
import ReportsPage from '@/pages/ReportsPage';
import EducationPage from '@/pages/EducationPage';
import MessagingPage from '@/pages/MessagingPage';
import AdminPage from '@/pages/AdminPage';
import PrivacyPage from '@/pages/PrivacyPage';
import LegalPage from '@/pages/LegalPage';
import TermsPage from '@/pages/TermsPage';
import CookieConsent from '@/components/CookieConsent';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

// Router component to handle session_id detection
function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id BEFORE rendering routes
  // This prevents race conditions with AuthProvider
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/auth" element={<AuthPage />} />
        <Route path="/auth/callback" element={<AuthCallback />} />
        <Route path="/confidentialite" element={<PrivacyPage />} />
        <Route path="/mentions-legales" element={<LegalPage />} />
        <Route path="/cgu" element={<TermsPage />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/dashboard/members" element={<MembersPage />} />
        <Route path="/dashboard/notes" element={<NotesPage />} />
        <Route path="/dashboard/tasks" element={<TasksPage />} />
        <Route path="/dashboard/appointments" element={<AppointmentsPage />} />
        <Route path="/dashboard/reports" element={<ReportsPage />} />
        <Route path="/dashboard/education" element={<EducationPage />} />
        <Route path="/dashboard/messages" element={<MessagingPage />} />
        <Route path="/dashboard/admin" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <CookieConsent />
      <Toaster position="top-right" richColors />
    </>
  );
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
